import { Injectable } from '@angular/core';
import { json } from 'express';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Nullable } from 'src/app/shared/constants/types';
import { UserService } from 'src/app/shared/http-services/user.service';
import { UserInfo } from 'src/app/shared/models/user-info.model';
import {} from 'src/app/shared/utils/utils-global';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUser$: Nullable<BehaviorSubject<UserInfo>> = null;

  constructor(private userService: UserService) {
	console.debugEx ("AuthService.CTOR");
  }

  public setCurrentUser(user: UserInfo): void {
	console.debugEx ("AuthService.setCurrentUser");
    this.currentUser$ = new BehaviorSubject<UserInfo>(new UserInfo(user));
  }

  public getCurrentUser(): Observable<UserInfo> {
	console.debugEx ("AuthService.getCurrentUser");
    return this.currentUser$
      ? this.currentUser$.asObservable()
      : this.callRequestGetMe();
  }

  private callRequestGetMe(): Observable<UserInfo> {
	console.debugEx ("AuthService.callRequestGetMe");
    return this.userService.getCurrentUserProfile().pipe(
      tap((user: UserInfo) => {
        this.setCurrentUser(user);
      }),
      map((user: UserInfo) => new UserInfo(user)),
    );
  }
}
